import { HttpParameterCodec } from '@angular/common/http';

export class CustomHttpParamEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }
    encodeValue(value: string): string {
            return encodeURIComponent(value);
    }
    decodeKey(key: string): string {
            return decodeURIComponent(key);
    }
    decodeValue(value: string): string {
            return decodeURIComponent(value);
    }
}

import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer extends DefaultUrlSerializer {

    serialize(tree: UrlTree): string {
        // for (const [key, value] of Object.entries(tree.queryParams)) {
        //     console.log(`${key}: ${value}`);
        //     tree.queryParams[key] = encodeURIComponent(value);
        // }
        // return super.serialize(tree);
        // console.log(tree);
        const url = super.serialize(tree);
        const parts = url.split("?");
        if (parts.length == 1) {
            return url;
        }
        const path = `${parts[0]}?${btoa(encodeURIComponent(parts[1]))}`;
        return path;
    }

    parse(url: string) : UrlTree {
        // console.log(url)
        const parts = url.split("?");
        if (parts.length == 1) {
            return super.parse(url);
        }
        const path = `${parts[0]}?${decodeURIComponent(atob(parts[1]))}`;
        return super.parse(path);
        // return decodeURIComponent(super.serialize(tree));
    }

}